import { render, staticRenderFns } from "./AuthorizationTypeBlock.vue?vue&type=template&id=c4f824e6&scoped=true&"
import script from "./AuthorizationTypeBlock.vue?vue&type=script&lang=ts&"
export * from "./AuthorizationTypeBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f824e6",
  null
  
)

export default component.exports